import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { INPUT_TYPES_MAP, InputTypeMap } from '@constants/input-types-map';
import { IDefaultSelect } from '@interfaces/default-select';
import { forkJoin, ReplaySubject } from 'rxjs';
import { enumPackageType } from '@data-layer/enums/lcl';
import { debounceTime, map, take, takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { enumLengthUnit, enumWeightUnit } from '@data-layer/enums/common';
import { PackageData } from '@app/modules/lcl-shipping/types';
import { IErrorForm } from '@shared/form-wrapper/interfaces';
import { PackageUpdateModel } from '@data-layer/models/lcl';

/* this is a copy of old component code, that is using old design, for now for edit quote/booking/shipment & admin */
/* now we use 'app-lcl-shipping-package-edit' */
@Component({
  selector: 'app-lcl-shipping-package-edit-old',
  templateUrl: './lcl-shipping-package-edit-old.component.html',
  styleUrls: ['./lcl-shipping-package-edit-old.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LclShippingPackageEditOldComponent implements OnInit, OnDestroy {
  @Input() public formGroup: UntypedFormGroup;
  @Input() public index: number;
  @Input() public isLastest: boolean;
  @Input() public isSidebar: boolean;
  @Input() public isAdminView: boolean;
  @Output() public removePackage: EventEmitter<number> = new EventEmitter<number>();
  @Output() public formUpdated: EventEmitter<PackageData> = new EventEmitter<PackageData>();

  public numberInputData: InputTypeMap = INPUT_TYPES_MAP.INTEGER;
  public decimalInputData: InputTypeMap = INPUT_TYPES_MAP.DECIMAL;
  public errors: IErrorForm = {
    required: 'LABELS.REQUIRED',
    min: 'LABELS.REQUIRED',
  };
  public typeErrors: IErrorForm = {
    required: 'FORM_ERROR.REQUIRED',
  };

  public typeSelect: IDefaultSelect[] = [];
  public weightUnits: enumWeightUnit[] = [enumWeightUnit.KG, enumWeightUnit.LB];
  public lengthUnits: enumLengthUnit[] = [enumLengthUnit.CENTIMETER, enumLengthUnit.INCH];

  private destroy$: ReplaySubject<void> = new ReplaySubject<void>();

  constructor(private translateService: TranslateService, private cdr: ChangeDetectorRef) {}

  public ngOnInit(): void {
    this.getTypeSelect();

    this.formGroup.valueChanges.pipe(debounceTime(300), takeUntil(this.destroy$)).subscribe((val: PackageUpdateModel) => {
      this.formUpdated.emit(this.formGroup.value);
    });
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
  }

  public onRemoveQuote(): void {
    this.removePackage.emit(this.index);
  }

  private getTypeSelect() {
    forkJoin(
      [
        enumPackageType.PALLET,
        enumPackageType.SKID,
        enumPackageType.CRATE,
        enumPackageType.BOX,
        enumPackageType.CARTON,
        enumPackageType.CASE,
        enumPackageType.PACKAGE,
        enumPackageType.DRUM,
        enumPackageType.BALE,
        enumPackageType.BAG,
      ].map((type) => this.translateService.get('PACKAGE_TYPE.' + enumPackageType[type]).pipe(map((label) => ({ label, value: type })))),
    )
      .pipe(take(1))
      .subscribe((select) => (this.typeSelect = select));
  }
}
